export const isPortraitMode = () => window.matchMedia("(orientation: portrait)").matches;
